import {z} from 'zod';

export const emailSchema = z.object({
    accountEmail: z.string().nullable(),
});

export type Email = z.infer<typeof emailSchema>;
